import { useEffect, useState } from 'react';
import AttributeFilter from './components/AttributeFilter';
import SearchInput from './components/SearchInput';

const SearchFilter = () => {
  const [mobileView, setMobileView] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setMobileView(true);
      } else {
        setMobileView(false);
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div
      style={{
        alignItems: 'center',
        display: 'flex',
        flex: 1,
        marginLeft: '10px',
        marginRight: '10px',
      }}
    >
      <AttributeFilter active={!mobileView} />
      <SearchInput />
    </div>
  );
};

export default SearchFilter;
